// 公共请求
import fetch from '@/common/utils/serFetch'
import { GATEWAYSER } from '@/common/config/index'

const moduleList = {
  selector: `${GATEWAYSER.SQSQT}/selector`
}

export const publicApi = {
  // 一二级级问题类型
  reqFirstType(reqData) {
    return fetch.get(`${moduleList.selector}/wo/firstType`, reqData)
  },
  // 消息通知
  geUnread(reqData){
    return fetch.post(`${GATEWAYSER.SQS_CUSTOMER}/userMessage/unread`, reqData)
  },
  // 已读标记
  reqMarkRead(reqData){
    return fetch.post(`${GATEWAYSER.SQS_CUSTOMER}/userMessage/markRead`, reqData)
  },
}

